import { render, staticRenderFns } from "./CandidatosSupporter.vue?vue&type=template&id=58ec07fc&scoped=true&lang=pug&"
import script from "./CandidatosSupporter.vue?vue&type=script&lang=js&"
export * from "./CandidatosSupporter.vue?vue&type=script&lang=js&"
import style0 from "./CandidatosSupporter.vue?vue&type=style&index=0&id=58ec07fc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec07fc",
  null
  
)

export default component.exports